var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grommet-icons:facebook-option"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1714 26.0997V15.9127H8.77539V11.668H12.1714V8.27194C12.1714 4.76289 14.3924 3.03662 17.5221 3.03662C19.0212 3.03662 20.3104 3.14848 20.6863 3.19806V6.86509H18.5149C16.8129 6.86509 16.4162 7.67576 16.4162 8.86235V11.668H20.6598L19.8111 15.9116H16.4162L16.4842 26.0997",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfb);
export default __webpack_public_path__ + "static/media/ffb.7e8f71500fec0143a18fd02acf99bb13.svg";
export { ForwardRef as ReactComponent };